import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useContext, useMemo, useState, } from 'react';
import { Tooltip } from '../Tooltip';
import { SwatchPickerContext } from './SwatchPickerContext';
import { SwatchPickerDesign } from './SwatchPickerDesign';
import { SwatchPickerStrikethrough } from './SwatchPickerStrikethrough';
import { useSwatchStyles } from './useSwatchStyles';
const swatchContainerStyles = css `
  position: relative;
`;
const tooltipContainerStyles = css `
  align-items: center;
  display: flex;
`;
const tooltipStyles = css `
  display: inline-flex;
`;
const inputStyles = css `
  position: absolute;
  visibility: hidden;
`;
const defaultProps = {
    ariaDescribedBy: undefined,
    ariaLabel: undefined,
    ariaLabelledBy: undefined,
    displayName: '',
    id: '',
    image: '',
    isDisabled: false,
    tooltipText: '',
};
const Swatch = ({ ariaDescribedBy = defaultProps.ariaDescribedBy, ariaLabel = defaultProps.ariaLabel, ariaLabelledBy = defaultProps.ariaLabelledBy, color, displayName = defaultProps.displayName, id = defaultProps.id, image = defaultProps.image, isDisabled = defaultProps.isDisabled, tooltipMinWidth, tooltipText = defaultProps.tooltipText, value, }) => {
    const { isLoading, name, onChange, optionType, selectedSwatches, shape, size, } = useContext(SwatchPickerContext);
    const isSelected = useMemo(() => (Array.isArray(selectedSwatches)
        ? selectedSwatches.includes(value)
        : selectedSwatches === value), [
        selectedSwatches,
        value,
    ]);
    const swatchDisplayName = useMemo(() => (displayName
        || value), [
        displayName,
        value,
    ]);
    const swatchId = useMemo(() => (id
        || `swatch-${value.replace(' ', '_')}-${Math.random()}`), [
        id,
        value,
    ]);
    const swatchStyles = useSwatchStyles({
        isDisabled,
        isLoading,
        isSelected,
        shape,
        size,
    });
    const [isTooltipVisible, setIsTooltipVisible,] = useState(false);
    const onMouseEnter = useCallback(() => (setIsTooltipVisible(true)), []);
    const onMouseLeave = useCallback(() => (setIsTooltipVisible(false)), []);
    return (_jsx("div", Object.assign({ css: swatchContainerStyles }, { children: _jsxs("div", Object.assign({ css: tooltipContainerStyles }, { children: [_jsxs("label", Object.assign({ css: swatchStyles, "data-test-ref": "swatch-radio-label", htmlFor: swatchId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, title: swatchDisplayName }, { children: [_jsx("input", { "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : name, "aria-labelledby": ariaLabelledBy, css: inputStyles, defaultChecked: isSelected, disabled: isLoading || isDisabled, id: swatchId, name: name, onChange: onChange, type: optionType, value: value }), isDisabled
                            && !isLoading
                            && (_jsx(SwatchPickerStrikethrough, {})), _jsx(SwatchPickerDesign, { color: color, imageUrl: image })] })), tooltipText
                    && (_jsx("div", Object.assign({ css: tooltipStyles }, { children: _jsx(Tooltip, Object.assign({ alignContent: "center", enterDelay: true, exitDelay: true, minWidth: tooltipMinWidth, placement: "bottom", showTooltip: isTooltipVisible }, { children: tooltipText })) })))] })) })));
};
const MemoizedSwatch = memo(Swatch);
export { MemoizedSwatch as Swatch };
// MC-1068 Temporary hack for Storybook.
export default Swatch;
